import type { FilterDataRange, FiltersGroup } from '@/app/common/filters/core/filtersTypes.ts';
import { FilterRangePill } from '@/app/common/filters/types/range/FilterRangePill.ts';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import { usePriceFilterScale, scaleRangeData } from '@/app/common/filters/surfaces/forms/custom/usePriceFilterScale.ts';
import TranslateSafeText from '@/app/common/components/TranslateSafeText';

// Budget pill label in the toggler's display unit; the underlying selection stays per person.
export const PriceRangeSelectionLabel = ({ filters }: FiltersGroup) => {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();
  const { scale } = usePriceFilterScale(FILTER_NAME.PRICE_RANGE);

  const filter = filters.find((f) => f.name === FILTER_NAME.PRICE_RANGE);
  if (!filter) return null;

  const displayFilter = { ...filter, data: scaleRangeData(filter.data as FilterDataRange, scale) };
  return <TranslateSafeText>{FilterRangePill(displayFilter, t, localization)[0]}</TranslateSafeText>;
};
